import { SWITCH_ACCOUNT_DEFAULT_PATH } from '@/store/mutation-types'

/** 无可用首页时的兜底路由（精英榜） */
export const FALLBACK_ROUTE_PATH = SWITCH_ACCOUNT_DEFAULT_PATH

/** 路由 path Set 缓存，避免每次菜单切换重建 */
let cachedRoutesRef = null
let cachedPathSet = null

/** 路由表变更后清缓存（GenerateRoutes / 切账号时调用） */
export function clearRoutePathCache() {
  cachedRoutesRef = null
  cachedPathSet = null
}

/** 从路由树收集所有可访问 path */
export function collectRoutePaths(routes = [], paths = new Set()) {
  routes.forEach(route => {
    if (route.path && route.path !== '*' && route.path !== '/') {
      paths.add(route.path)
    }
    if (route.children && route.children.length) {
      collectRoutePaths(route.children, paths)
    }
  })
  return paths
}

function getCachedPathSet(routes = []) {
  if (routes === cachedRoutesRef && cachedPathSet) {
    return cachedPathSet
  }
  cachedRoutesRef = routes
  cachedPathSet = collectRoutePaths(routes)
  return cachedPathSet
}

export function isPathInRoutes(path, routes = []) {
  if (!path) {
    return false
  }
  return getCachedPathSet(routes).has(path)
}

/** 优先精英榜，否则取第一个可用业务路由 */
export function resolveFallbackRoutePath(routes = [], preferredPath = FALLBACK_ROUTE_PATH) {
  const paths = getCachedPathSet(routes)
  if (paths.has(preferredPath)) {
    return preferredPath
  }
  let fallback = null
  const walk = (list = []) => {
    for (const route of list) {
      if (
        route.path &&
        route.path !== '*' &&
        route.path !== '/' &&
        route.path !== '/index' &&
        !route.hidden
      ) {
        fallback = route.path
        return true
      }
      if (route.children && route.children.length && walk(route.children)) {
        return true
      }
    }
    return false
  }
  walk(routes)
  return fallback
}
